import React from "react";
import { Sparkles } from "lucide-react";

const VitrineHero = () => {
  return (
    <section className="relative overflow-hidden rounded-3xl border border-yellow-500/30 bg-gradient-to-br from-black via-zinc-900 to-black p-8 md:p-14 shadow-2xl">
      <div className="absolute -top-20 -right-20 w-80 h-80 bg-yellow-500/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-amber-500/10 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-3xl">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 text-xs font-bold uppercase tracking-wider mb-4">
          <Sparkles className="h-3.5 w-3.5" />
          Vitrine de Ferramentas
        </div>
        <h1 className="text-3xl md:text-5xl font-extrabold text-white leading-tight">
          Conheça <span className="bg-gradient-to-r from-yellow-400 to-amber-500 bg-clip-text text-transparent">tudo</span> que o IA Palpite Guru oferece
        </h1>
        <p className="mt-4 text-zinc-300 text-base md:text-lg">
          Mais de <span className="text-yellow-400 font-bold">25 ferramentas</span> entre métodos exclusivos, IA, estatísticas em tempo real, resultados ao vivo e muito mais — tudo num só lugar.
        </p>

        <div className="mt-6 flex flex-wrap gap-3 text-xs md:text-sm">
          {["16 Métodos", "IA Avançada", "Estatísticas", "Resultados ao vivo", "Loja", "Afiliados"].map((tag) => (
            <span
              key={tag}
              className="px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-zinc-200"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VitrineHero;
